import { Box } from '@factorialco/deprecated-design-system'
import { F0TagStatus } from '@factorialco/f0-react'

import { mapSaleInvoiceStatusText, saleInvoiceStatusTagType } from 'modules/finance/lib/invoices'

interface StatusProps {
  validated?: boolean
  registered?: boolean
}

export const SaleInvoiceStatus = ({ validated, registered }: StatusProps) => {
  return (
    <Box alignItems="flexStart">
      <F0TagStatus
        text={mapSaleInvoiceStatusText(validated, registered)}
        variant={saleInvoiceStatusTagType(validated, registered)}
      />
    </Box>
  )
}
